import React, {useState} from "react";
import styles from "./chat-input.module.css";
import {addMessage, setName, setWaitingResponse} from "../../store/stateSlice";
import {useDispatch} from "react-redux";
import {updateProfile} from "../../../../api";

const ChatInput = ({ title }) => {
  const [answered, setAnswered] = useState(false);
  const [input, setInput] = useState("");

  const dispatch = useDispatch();

  const handleOnSend = () => {
    if (input) {
      dispatch(setName(input))
      dispatch(addMessage(input));
      dispatch(setWaitingResponse());
      setAnswered(true);

      updateProfile({
        land: "tarot-chat",
        step: "step1",
        topicType: "name",
        topic: title,
        answer: {
          name: input
        }
      })
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleOnSend();
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.input_text}>{title}</p>
      {!answered && (
        <div className={styles.input_container}>
          <input
            type="text"
            value={input}
            onInput={(e) => setInput(e.target.value)}
            placeholder="Enter your name here..."
            className={styles.input}
            onKeyDown={handleEnter}
          />
          <button className={styles.button} onClick={handleOnSend}></button>
        </div>
      )}
    </div>
  );
};

export { ChatInput };
